import { $http, Constants } from '@/store/actions/constants';

let url = `${Constants.BaseURL}/company`;

export const companyActions = {

    companyInfo({ commit, state }) {
        return $http.get(`${Constants.BaseURL}/auth/check`, state.authHeader).then(res => {
            if (res.status === 200 && res.data) {
                commit('SET_COMPANY_INFO', {
                    status: res.data.status,
                    logoUrl: res.data.logo_url,
                    name: res.data.company_name,
                    location: res.data.location,
                    companyId: res.data.company_id,
                    // membership: res.data.membership,
                    // orgNr: res.data.org_nr,
                });
            }
        })
    },

    company: ({ commit, state }) => {
        return $http.get(url, state.authHeader).then(r => {
            if (r.status === 200) {
                commit('SET_COMPANY', r.data);
            }
        });
    },

    update: ({ dispatch, commit, state }, data) => {
        return $http.post(url, data, state.authHeader).then(r => {
            if (r.status === 200) {
                commit('SET_COMPANY', r.data);
                dispatch('companyInfo');
            }
        });
    },

    updateLogo: ({ dispatch, commit, state }, data) => {
        return $http.post(`${url}/updateLogo`, data, state.authHeader).then(r => {
            if (r.status === 200) {
                dispatch('company');
            }
        });
    },

    saveMembership: ({ commit, state }, data) => {
        return $http.post(`${url}/membership`, data, state.authHeader);
    },

    timeline: ({ commit, state }) => {
        return $http.get(`${url}/timeline`, state.authHeader).then(res => {
            if (res.status === 200) {
                commit("SET_COMPANY_TIMELINE", res.data);
            }
        });
    },

    startBillingSession: ({ commit, state }) => {
        return $http.get(`${url}/membership/session`, state.authHeader);
    },
   
    membershipInfo: ({ commit, state }) => {
        return $http.get(`${url}/membership/info`, state.authHeader);
    },

    membershipSessionCancelled: ({ commit, state }) => {
        return $http.get(`${url}/membership/cancelledStatus`, state.authHeader);
    }

};
